/*jshint esversion: 6 */
import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}WorkPackagesImagesZoom`,
    path: 'images',
    folder: 'Project/TaktPlanWorkPackage',
    file: 'TaktPlanWorkPackageImagesZoom',
    auth:true,
    props: (route) => {
      let props = {
        image_id: parseInt(route.params.image_id),
        location: payload.location,
        close: payload.close,
        create: payload.create
      };
      if (payload.create) {
        props.images = store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {workpackage: ''},
            {wworkpackageimages: ''}
          ]
        });
      } else if (route.params.template_type) {
        let prefix = '';
        switch (route.params.template_type) {
          case 'custom':
          prefix = '';
          break;
          case 'company':
          prefix = 'b';
          break;
          case 'community':
          prefix = 'c';
          break;
        }
        props.images = store.getters['WorkBench/getWBObjects']({
          type: `${prefix === 'b'? '':'w'}workpackageimages`,
          ids: store.state.WorkBench[`${prefix}workpackages`][parseInt(route.params.workpackage_id)][`${prefix === 'b'? '':'w'}workpackageimages`]
        });
      } else {
        props.images = store.getters['Ultra/getUObjects']({
          type: 'tworkpackageimages',
          ids: store.state.Ultra.tworkpackages[route.params.tworkpackage_id].tworkpackageimages
        });
      }
      return props;
    },
    children: [
      UltraRoute({
        name: `${payload.location}WorkPackagesImagesZoomImage`,
        path: ':image_id',
        folder: 'Project/TaktPlanWorkPackage',
        file: 'TaktPlanWorkPackageImagesZoomImage',
        auth:true,
        props: (route) => {
          let props = {};
          if (payload.create) {
            props.image = store.getters['WorkBenchLocal/getWBLObject']({
              path: [
                {workpackage: ''},
                {wworkpackageimages: route.params.image_id}
              ]
            });
          } else if (route.params.template_type) {
            let prefix = '';
            switch (route.params.template_type) {
              case 'custom':
              prefix = '';
              break;
              case 'company':
              prefix = 'b';
              break;
              case 'community':
              prefix = 'c';
              break;
            }
            props.image = store.state.WorkBench[`${prefix === 'b'? '':'w'}workpackageimages`][route.params.image_id];
          } else {
            props.image = store.state.Ultra.tworkpackageimages[route.params.image_id];
          }
          return props;
        }
      })
    ]
  })
  return route;
}
export default Template;
